import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  Button,
  Row,
  Col,
  Form,
  Spinner,
  Container,
} from "reactstrap";
import { useDropzone } from "react-dropzone";
import Dropzone from "react-dropzone";

import { useDispatch, useSelector } from "react-redux";
import { updateMemoirMedia } from "../../redux/actions/memoir.action";
import { toast } from "react-toastify";
import { customAlert } from "../../redux/actions/alertActions";
import CustomDatePicker from "../CustomDatePicker";
import moment from "moment";

function AddMedia(props) {
  const [files, setFiles] = useState([]);
  const [index, setIndex] = useState(0);
  const [display_image, setDisplay_imgage] = useState("");
  const [cover_image, setCover_image] = useState("");
  const [media_date, setMedia_date] = useState("");
  const [media_heading, setMedia_heading] = useState("");
  const [media_desc, setMedia_desc] = useState("");
  const { mediaLoading } = useSelector((state) => state.memoir);
  const [inputList, setInputList] = useState([
    { date: "", title: "", description: "", media: [] },
  ]);

  const dispatch = useDispatch();

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
    setIndex(index);
  };

  const handleAddClick = () => {
    console.log(inputList, "input list");
    setInputList([
      ...inputList,
      { date: "", title: "", description: "", media: [] },
    ]);
  };
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  const removeImage = (idx, i) => {
    let object = inputList.find((_, index) => index === idx);
    let newObj = object.media.filter((_, index) => index !== i);
    const list = [...inputList];
    list[idx]["media"] = newObj;
    setInputList(list);
  };

  return (
    <>
      <Modal
        isOpen={props.isOpen.addMedia}
        size="lg"
        centered
        className="custom-modal"
        toggle={(e) => {
          setFiles([]);
          props.toggleModal("addMedia");
        }}
      >
        <ModalBody>
          <Form
            onSubmit={async (e) => {
              e.preventDefault();
              if (inputList[0].date == "" || inputList[0].title == "") {
                alert("Please select date and add title");
              } else {
                await dispatch(updateMemoirMedia(inputList, props.id));
                props.toggleModal("addMedia");
              }
            }}
          >
            <div>
              <div className="d-flex">
                <div className="ml-auto pointer">
                  <i
                    className="fa fa-times"
                    onClick={(e) => {
                      setFiles([]);
                      props.toggleModal("addMedia");
                    }}
                  ></i>
                </div>
              </div>
              <h5 className="font-weight-bold text-center">
                Add to your memoir
              </h5>
              {inputList?.map((item, idx) => {
                console.log("item", item.media);
                return (
                  <>
                    <div className="row mt-5">
                      <div className="col">
                        <label className="m-0">Start date</label>
                        <div className="row">
                          <div className="col-12">
                            <CustomDatePicker
                              id={"test"}
                              name="date"
                              value={item.date}
                              max={moment().toISOString().substring(0, 10)}
                              onChange={(e) => handleInputChange(e, idx)}
                              isRequired={false}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col">
                        <label className="m-0">Title</label>
                        <div className="row">
                          <div className="col-12">
                            <input
                              value={item.title}
                              name="title"
                              onChange={(e) => handleInputChange(e, idx)}
                              type="text"
                              className="form-control"
                              placeholder="Title"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="position-relative">
                      <Dropzone
                        onDrop={(acceptedFiles) => {
                          let tempFiles = acceptedFiles.map((file) =>
                            Object.assign(file, {
                              preview: URL.createObjectURL(file),
                            })
                          );
                          let tempArr = item.media.concat(tempFiles);
                          const list = [...inputList];
                          list[idx]["media"] = tempArr;
                          setInputList(list);
                        }}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <section>
                            <div {...getRootProps()} className="mt-5">
                              <input {...getInputProps()} />
                              <div
                                className="jumbotron ml-0 "
                                style={{
                                  paddingLeft: 10,
                                  marginBottom: 10,
                                  borderStyle: "dashed",
                                  borderRadius: 5,
                                  borderWidth: 1,
                                  borderColor: "black",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  textAlign: "center",
                                  left: "50%",
                                }}
                              >
                                <p className="plus_icon">+</p>
                                <p
                                  style={{ cursor: "default" }}
                                  className="text-black text-lg"
                                >
                                  <span className="sub_text">
                                    Add Photo/Videos
                                  </span>{" "}
                                  or drop file here
                                </p>
                              </div>
                            </div>
                          </section>
                        )}
                      </Dropzone>
                      <Container className="mb-5">
                        <Row className="d-flex flex-row position-absolute dropzone-file-box">
                          {item?.media?.map((image, i) => {
                            // console.log("images", idx, image, i);
                            return (
                              <Col
                                key={image?.name}
                                className="d-flex mt-2"
                                xs="3"
                              >
                                <div style={{ position: "relative" }}>
                                  <i
                                    className="fas fa-minus-circle"
                                    style={{
                                      color: "red",
                                      position: "absolute",
                                      top: "0%",
                                      right: "0%",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      removeImage(idx, i);
                                    }}
                                    // onClick={(i) => {
                                    //   let array = item.media.filter(
                                    //     (index) => index !== i
                                    //   );
                                    //   console.log("array", array);
                                    // }}
                                    //   // files.splice(index, 1);
                                    //   // setFiles([...files]);
                                  ></i>

                                  {image.type.split("/")[0] == "image" && (
                                    <img
                                      src={image.preview}
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                      }}
                                      alt="preview"
                                      className="mx-2 mt-2"
                                    ></img>
                                  )}

                                  {image?.type.split("/")[0] == "video" && (
                                    <video
                                      src={image.preview}
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                      }}
                                      alt="preview"
                                      className="mx-2 mt-2"
                                    ></video>
                                  )}

                                  {image?.type.split("/")[0] == "audio" && (
                                    <img
                                      src={
                                        "https://firebasestorage.googleapis.com/v0/b/memora-admin-platform.appspot.com/o/arafsd.png?alt=media&token=d6f72de3-793e-4af5-8e3c-c676d20c442a"
                                      }
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                      }}
                                      alt="preview"
                                      className="mx-2 mt-2"
                                    ></img>
                                  )}
                                </div>
                              </Col>
                            );
                          })}
                        </Row>
                      </Container>
                    </div>
                    <label className="mt-3">Add a description</label>
                    <textarea
                      rows={5}
                      value={item?.description}
                      name="description"
                      onChange={(e) => handleInputChange(e, idx)}
                      className="form-control"
                    />
                    {inputList?.length > 1 && (
                      <button
                        className="btn btn-outline f14 mr-3 dashboard-btn mt-5"
                        type="button"
                        onClick={() => handleRemoveClick(idx)}
                      >
                        Remove
                      </button>
                    )}

                    <div className="d-flex mt-4 justify-content-end">
                      {inputList.length - 1 == idx && (
                        <button
                          className="btn btn-outline f14 mr-3 dashboard-btn"
                          type="button"
                          // disabled={
                          //   mediaLoading ||
                          //   (!media_date &&
                          //     !media_desc &&
                          //     !media_heading &&
                          //     files.length == 0)
                          // }
                          onClick={() => handleAddClick()}
                        >
                          + Add More
                        </button>
                      )}
                      <button
                        type="submit"
                        className="btn btn-outline f14 dashboard-btn"
                        // onClick={async (e) => {
                        //   e.preventDefault();
                        //   dispatch(updateMemoirMedia(inputList, props.id));
                        //   setInputList([
                        //     { media: "", title: "", description: "", date: "" },
                        //   ]);

                        // }}
                      >
                        {mediaLoading ? <Spinner size="sm" /> : "Submit"}
                      </button>
                    </div>
                  </>
                );
              })}
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
}

export default AddMedia;
